module.exports = __webpack_public_path__ + "static/media/success-notification-icon.3252dcb5.svg";